const BRAND = ["#E91E8C", "#D946EF", "#7C3AED", "#6A5ACD", "#8B5CF6", "#A78BFA"];

export type ChartPalette = {
  textColor: string;
  secondaryTextColor: string;
  borderColor: string;
  axisLineColor: string;
  splitLineColor: string;
  backgroundColor: string;
  labelColor: string;
  colors: string[];
  emphasisIconBorder: string;
  pieLabelBg: string;
};

const DARK: ChartPalette = {
  textColor: "#E2E8F0",
  secondaryTextColor: "#94A3B8",
  borderColor: "#475569",
  axisLineColor: "#475569",
  splitLineColor: "#334155",
  backgroundColor: "#0F172A",
  labelColor: "#94A3B8",
  colors: BRAND,
  emphasisIconBorder: "#FFFFFF",
  pieLabelBg: "rgba(50, 50, 50, 0.1)",
};

const LIGHT: ChartPalette = {
  textColor: "#0f172a",
  secondaryTextColor: "#475569",
  borderColor: "#64748b",
  axisLineColor: "#94a3b8",
  splitLineColor: "#e2e8f0",
  backgroundColor: "#ffffff",
  labelColor: "#334155",
  colors: BRAND,
  emphasisIconBorder: "#1e293b",
  pieLabelBg: "rgba(15, 23, 42, 0.06)",
};

export function getChartPalette(isDarkMode: boolean): ChartPalette {
  return isDarkMode ? DARK : LIGHT;
}

/** Shell for loading / empty states inside chart cards */
export const chartStateShell =
  "flex h-[350px] w-full items-center justify-center";
